import type { DefaultContext } from '@apollo/client'

import { buildUrl } from 'modules/core/lib/buildUrl'
import { isAbsoluteURL } from 'modules/core/lib/isAbsoluteURL'

const getProductCatalogGraphQLEndpoint = (): string | undefined => {
  const viteEndpoint =
    typeof import.meta !== 'undefined' && import.meta.env
      ? import.meta.env.VITE_PRODUCT_CATALOG_GRAPHQL_ENDPOINT
      : undefined

  if (viteEndpoint && typeof viteEndpoint === 'string') {
    return viteEndpoint
  }

  return undefined
}

export const createProductCatalogQueryContext = (
  useProductCatalogService = false,
  additionalContext?: Partial<DefaultContext>
): DefaultContext => {
  const customUri = useProductCatalogService ? getProductCatalogGraphQLEndpoint() : undefined

  return {
    ...(customUri ? { uri: customUri } : {}),
    ...additionalContext,
  }
}

const isProductCatalogUrl = (url: string): boolean => {
  const endpoint = getProductCatalogGraphQLEndpoint()
  if (!endpoint) return false

  try {
    const endpointUrl = new URL(endpoint)
    const urlObj = new URL(url)
    return urlObj.origin === endpointUrl.origin
  } catch {
    return false
  }
}

const buildProductCatalogUrl = (path: string | undefined | null): string => {
  if (!path) return ''

  if (isAbsoluteURL(path)) return path

  const endpoint = getProductCatalogGraphQLEndpoint()
  if (endpoint) {
    try {
      const url = new URL(endpoint)
      return `${url.origin}${path}`
    } catch {}
  }

  return buildUrl(path)
}

export const buildProductImageUrl = (
  imageUrl: string | null | undefined,
  useProductCatalogService: boolean,
  fallbackUrl?: string
): string => {
  if (!imageUrl) {
    return fallbackUrl || ''
  }

  if (useProductCatalogService) {
    return buildProductCatalogUrl(imageUrl)
  }

  return buildUrl(imageUrl)
}
